<template>

    <div>

<!--        <nav-bar :selected="-1" @search="getSearchInfo"/>-->

        <div class="index">

            <div class="search">

                <div class="search-tab">

                    <span>筛选结果: </span>

                    <span
                        v-for="(item,index) in tabs"
                        :key="'tab-span-'+index"
                        :style="{ color: selected == index ? '#8F5FF5' : '#999999' }"
                        @click="changeTab(index)"
                    >

                    {{ item.label }}

                </span>

                </div>

                <div v-if="(selected === 0 || selected === 3) && list.length > 0" class="search-content">

                    <layout-list-item
                        v-for="(item,index) in list"
                        :key="'news-item-'+index"
                        :data="item"
                        :type="type"
                    />

                </div>

                <div v-if="selected === 1 && list.length > 0" class="search-content">

                    <div class="star cf">

                        <star-avatar-item
                            class="star-item fl"
                            v-for="(item,index) in list"
                            :key="'star-item-'+index"
                            :data="item"
                            :width="160"
                            :height="160"
                            :font-size="28"
                        />

                    </div>

                </div>

                <div v-if="selected === 2 && list.length > 0" class="search-content cf">

                    <layout-active-item
                        v-for="(item,index) in list"
                        :key="'search-active-'+index"
                        :data="item"
                    />

                </div>

                <div v-if="list.length <= 0" class="empty">

                    暂无搜索结果

                </div>

            </div>

        </div>

    </div>

</template>

<script>
import mixin from "./mixin/mixin";
import NavBar from '../../layout/navbar/main';
import LayoutListItem from '../../layout/layout-list-item/main';
import LayoutActiveItem from '../../layout/layout-active-item/main';
import StarAvatarItem from '../../layout/starAvatarItem/main';

export default {
    name: "search",
    mixins: [mixin],
    components: {
        StarAvatarItem,
        LayoutListItem,
        LayoutActiveItem,
        NavBar
    }
}
</script>

<style scoped src="./style.css"></style>
